import {Component, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {CommonService} from '../@shared/services/common.service';
import {NotificationService} from '../@shared/new-services/notification.service';
import {MessageService} from 'primeng/api';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    notifications: any;
    pagedNotification: any;
    selectedFilterStatus: any = 'All';
    filterStatusArray: any = [
        'All',
        'Booking Created',
        'Booking Confirmed',
        'Customs Cleared',
        'Cargo Stuffed',
        'Shipment Planned',
        'Shipment Sailed',
        'Shipment Arrived',
        'Shipment Delivered',
    ];
    screenSize = window.innerWidth;
    displayNotificationDialog = false;

    constructor(private commonService: CommonService,
                public platform: Platform,
                private notificationService: NotificationService,
                private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.getPagedNotificationByStatus();
        this.updateNotificationAsRead(true);
    }

    getPagedNotificationByStatus(page?: number, size?: number, statusFilter?: string) {
        if (!page) {
            page = 0;
        }
        if (!size) {
            size = 10;
        }
        if (!statusFilter) {
            statusFilter = 'All';
        }
        this.notificationService.getNotifications(statusFilter, page, size)
            .subscribe((res) => {
                this.notifications = res?.content;
                this.pagedNotification = res;
            }, error => {
                console.log(error);
            });
    }

    paginateFilteredNotification(paginateData) {
        this.getPagedNotificationByStatus(paginateData?.page, 10, this.selectedFilterStatus);
    }

    applyStatusFilter(status: string) {
        console.log(status);
        this.selectedFilterStatus = status;
        this.getPagedNotificationByStatus(0, 10, this.selectedFilterStatus);
    }

    updateNotificationAsRead(markAllAsRead) {
        this.commonService.updateNotificationAsRead(markAllAsRead)
            .subscribe((res) => {
                console.log(res);
            }, error => {
                console.log(error);
            });
    }

    markNotificationAsTrue(notification: any) {
        const notificationsList: any[] = [];
        notificationsList.push(notification);
        this.notificationService
            .markSelectedNotificationAsRead(notificationsList, false)
            .subscribe((x) => {
                this.presentToastMessage('success', 'Notification : ' + notification?.bookingId + ' Cleared !');
                this.getPagedNotificationByStatus();
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    markAllNotificationsAsRead() {
        this.notificationService
            .markSelectedNotificationAsRead([], true)
            .subscribe((x) => {
                this.presentToastMessage('success', 'Notifications Cleared !');
                this.getPagedNotificationByStatus();
            }, error => {
                this.presentToastMessage('error', error?.message ? error?.message : error);
            });
    }

    presentToastMessage(severity, detail) {
        this.messageService
            .add(
                {
                    severity,
                    summary: 'Notifications Message',
                    key: 'notification-message',
                    detail,
                }
            );
    }
}
